import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AddNonDubaiHealthChild from "./AddNonDubaiHealthChild";
import {
  checkUserPresent,
  getDependentDetails,
  getDependentListData,
  getIdamUserDetails,
  getParentInfoByMrn } from
"../../../services/liferay/baraemServices";
import BaraemMobileNumberVerify from "./BaraemMobileNumberVerify";
import AlertDependent from "../../../common/AlertDependent";
import { capitalizeFirstLetter, configureFirstIframe, getLayoutDirection, isLiferayEnv } from "../../../utils/util";
import { Loader } from "../../../common/Loader";

const AddChild = ({ translationMap }) => {
  const [step, setStep] = useState(-1);
  const navigate = useNavigate();
  const [isDubaiHealthFacility, setIsDubaiHealthFacility] = useState(true);
  const [mobileNumberVerificationPupup, setMobileNumberVerificationPupup] =
  useState(false);

  const [patientFirstName, setPatientFirstName] = useState("");
  const [patientSex, setPatientSex] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [patientMobile, setPatientMobile] = useState("");
  const [uuid, setUuid] = useState("");
  const [mrn, setMrn] = useState("");
  const [error, setError] = useState(false);
  const [inputDob, setInputDob] = useState("");
  const [ageInMonth, setAgeInMonth] = useState();
  const [dependentList, setDependentList] = useState([]);
  const [, setSelectedChild] = useState(null);
  const [isDropdownSelected, setIsDropdownSelected] = useState(false);
  const [isLiferay, setIsLiferay] = useState(true);
  const [userAlreadyPresentError, setUserAlreadyPresentError] = useState(false);
  const [otpBlockError, setOtpBlockError] = useState(false);
  const [continueClicked, setContinueClicked] = useState(false);
  const [selectedMrnFromDropDown, setSelectedMrnFromDropDown] = useState(false);
  const currentYear = new Date().getFullYear();
  const [ageError, setAgeError] = useState(false);
  const [birthYearError, setBirthYearError] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [hcNumberError, setHcNumberError] = useState(false);


  const handlePatientData = (data) => {
    setPatientFirstName(data.PatientFirstName || "");
    setPatientSex(data.patientSex || "");
    setDateOfBirth(formatDate(data.dateofBirth) || "");
    // setPatientMobile(data.patientMobile || "");
  };

  const formatDate = (dob) => {
    if (!dob) return "";
    const year = dob.slice(0, 4);
    const month = dob.slice(4, 6);
    const day = dob.slice(6, 8);
    return `${day}/${month}/${year}`;
  };

  const calculateAge = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);

    const userDob = new Date(year, month - 1, day);
    const today = new Date();

    const yearDiff = today.getFullYear() - userDob.getFullYear();
    const monthDiff = today.getMonth() - userDob.getMonth();

    let totalMonths = yearDiff * 12 + monthDiff;
    if (today.getDate() < userDob.getDate()) {
      totalMonths -= 1;
    }
    return totalMonths;
  };

  const handleFacilityChange = (event) => {
    setMrn("");
    setIsDropdownSelected(false);
    setInputDob("");
    setError(false);
    setUserAlreadyPresentError(false);
    setSelectedMrnFromDropDown("");
    setIsDubaiHealthFacility(event.target.id === "baraemtest1");
  };

  const handleChangeMrn = (e) => {
    let inputValue = e.target.value;
    setHcNumberError(false);


    inputValue = inputValue.replace(/[^0-9]/g, "");


    setMrn(inputValue);

    setSelectedChild(null);
    setIsDropdownSelected(false);
    setUserAlreadyPresentError(false);
    setAgeError(false);
    setError(false);
    setSelectedMrnFromDropDown("");
  };
  const handleChangeUserInputDob = (e) => {
    setBirthYearError(false);
    let inputValue = e.target.value;
    if (/^\d{0,4}$/.test(inputValue)) {
      setInputDob(inputValue);

    }
    setError(false);
    setAgeError(false);
    setUserAlreadyPresentError(false);
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    setError(false);
    setAgeError(false);
    setUserAlreadyPresentError(false);
    setHcNumberError(false);
    setBirthYearError(false);
    if (!isLiferay) {

      if (isDubaiHealthFacility && !isDropdownSelected) {
        if (
        !inputDob ||
        inputDob.length < 4 ||
        Number(inputDob) > currentYear ||
        !mrn ||
        mrn.length < 7 ||
        mrn.length > 10)
        {
          if (!inputDob || inputDob.length < 4 || Number(inputDob) > currentYear) {
            setBirthYearError(true);
          }
          if (mrn.length < 7 || mrn.length > 10) {
            setHcNumberError(true);
          }
          return;
        }


        try {
          // console.log("Checking MRN in DB for Non-Liferay user...");
          await checkMrnInDb(mrn, inputDob);
        } catch (error) {
          console.error(" Error fetching MRN details:", error);
          setError(true);
        }
      } else {
        try {
          // console.log("Fetching Parent Info for Non-Liferay user non dubai...");
          //  setStep(1);

          const parentInfoResponse = await getParentInfoByMrn();

          if (parentInfoResponse.status === 200) {
            setPatientMobile(parentInfoResponse.data.patientMobile);
            setStep(1);
          } else {
            console.error(" Parent info not found");
            setError(true);
          }
        } catch (error) {
          console.error(" Error fetching parent info:", error);
          setError(true);
        }
      }
    }

    //  Liferay flow
    else {
      try {

        if (!isDubaiHealthFacility) {
          setIsApiLoading(true);
          // console.log("Fetching IDAM user details for Liferay user...");

          const response = await getIdamUserDetails();
          setIsApiLoading(false);

          if (response.status === 200) {
            // console.log(" Liferay API Success (200)");
            setPatientMobile(response.data.patientMobile);
            setStep(1);

          } else if (response.status === 400) {

            setError(true);
          }
        } else {
          try {
            if (
            !inputDob ||
            inputDob.length < 4 ||
            Number(inputDob) > currentYear ||
            !mrn ||
            mrn.length < 7 ||
            mrn.length > 10)
            {
              if (!inputDob || inputDob.length < 4 || Number(inputDob) > currentYear) {
                setBirthYearError(true);
              }
              if (mrn.length < 7 || mrn.length > 10) {
                setHcNumberError(true);
              }
              return;
            }

            await checkMrnInDb(mrn, inputDob);
          } catch (error) {
            console.error(" Error fetching MRN details:", error);
            setError(true);
          }

        }
      } catch (error) {
        setIsApiLoading(false);
        console.error(" Error occurred in Liferay flow", error);
        setError(true);
      }
    }
  };

  const checkMrnInDb = async (mrn, inputDob) => {
    try {
      setAgeError(false);
      setError(false);
      setUserAlreadyPresentError(false);
      setHcNumberError(false);
      setBirthYearError(false);
      setIsApiLoading(true);

      const response = await checkUserPresent({ mrn: mrn, inputDob: inputDob });

      setIsApiLoading(false);
      if (response?.data?.message === "otpBlocked")
      {
        setOtpBlockError(true);
        return;
      } else
      if (response.status === 200) {

        setMobileNumberVerificationPupup(true);
        setPatientMobile(response.data.maskedMobilNumber);
        setUuid(response.data.smsid);
      }

    } catch (error) {
      setIsApiLoading(false);

      if (error.response) {


        if (error.response.status === 400) {


          if (error.response.data.message2 === "unableToFindChildSubText") {

            setError(true);
          } else if (error.response.data.message2 === "recordAlreadyPresent") {

            setUserAlreadyPresentError(true);
          } else
          {

            setAgeError(true);
          }
        } else {

          setError(true);
        }
      } else {

        setError(true);
      }
    }
    window.parent.scrollTo(0, 0);
  };


  useEffect(() => {
    window.parent.scrollTo(0, 0);
    configureFirstIframe(1000, 1300, true);
    const preventScrollOnFocus = (e) => {
      if (document.activeElement.type === "number") {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", preventScrollOnFocus, { passive: false });

    return () => {
      window.removeEventListener("wheel", preventScrollOnFocus);
    };
  }, []);

  useEffect(() => {
    if (isLiferayEnv()) {
      setIsLiferay(true);
    } else {
      setIsLiferay(false);
    }
  }, []);
  const calculateAgeInMonths = (dob) => {
    const year = parseInt(dob.slice(0, 4), 10);
    const month = parseInt(dob.slice(4, 6), 10);
    const day = parseInt(dob.slice(6, 8), 10);

    const dobDate = new Date(year, month - 1, day);
    const currentDate = new Date();

    const yearDiff = currentDate.getFullYear() - dobDate.getFullYear();
    const monthDiff = currentDate.getMonth() - dobDate.getMonth();
    const dayDiff = currentDate.getDate() - dobDate.getDate();

    let totalMonths = yearDiff * 12 + monthDiff;
    if (dayDiff < 0) {
      totalMonths -= 1;
    }

    return totalMonths;
  };

  useEffect(() => {
    if (!isLiferay) {
      const fetchDependent = async () => {
        try {
          const getDependentListResponse = await getDependentDetails();
          if (getDependentListResponse.status === 200) {
            const getDependentList = getDependentListResponse.data;
            const filteredData = getDependentList.filter((item) => {
              const ageInMonths = calculateAgeInMonths(item.dateofBirth);
              return ageInMonths < 72;
            });
            setDependentList(filteredData);
          }
        } catch (err) {
          console.error("Error fetching dependent details:", err);
        }
      };

      fetchDependent();
    }
  }, [isLiferay]);

  const handleChildChange = (e) => {
    const selectedValue = e.target.value;
    const child = dependentList.find(
      (entry) => entry.patientMRN === selectedValue
    );
    if (child) {
      setSelectedChild(child);
      handlePatientData(child);
      setSelectedMrnFromDropDown(child.patientMRN);

      setPatientMobile(child.patientMobile || "");
      setInputDob("");
      setMrn("");
      setAgeInMonth(calculateAge(formatDate(child.dateofBirth)));
      setIsDropdownSelected(true);
      setUserAlreadyPresentError(false);
      setError(false);
      setAgeError(false);
      setHcNumberError(false);
      setBirthYearError(false);

    }
  };

  useEffect(() => {
    const checkAndSendOTP = async () => {
      try {
        setIsApiLoading(true);

        if (continueClicked && isDropdownSelected) {

          const result = await getDependentListData(
            {
              mrn: isDropdownSelected ? selectedMrnFromDropDown : mrn
            });
          if (result?.data?.message === "otpBlocked")
          {
            setIsApiLoading(false);
            setOtpBlockError(true);
            return;
          } else
          if (result.status === 200) {

            setIsApiLoading(false);
            setMobileNumberVerificationPupup(true);
            setPatientMobile(result.data.maskedMobilNumber);
            setUuid(result.data.smsid);
          } else

          {
            setUserAlreadyPresentError(true);
          }
          setContinueClicked(false);
        }
        setIsApiLoading(false);


      } catch (error) {
        setIsApiLoading(false);
        setContinueClicked(false);

        if (error.response) {


          if (error.response.status === 400) {


            if (error.response.data.message2 === "unableToFindChildSubText") {

              setError(true);
            } else if (error.response.data.message2 === "recordAlreadyPresent") {

              setUserAlreadyPresentError(true);
            } else
            {

              setAgeError(true);
            }
          } else {

            setError(true);
          }
        } else {

          setError(true);
        }
      }

    };
    checkAndSendOTP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [continueClicked]);

  const handleDropdownContinue = () => {

    if (isDropdownSelected) {


      setContinueClicked(true);

    }
  };

  if (isApiLoading) {
    return (
      <Loader />);

  }

  return (
    <div className={` custombody_color ${getLayoutDirection()}`} id="sectionManageDependent">

      <div>
        {step === -1 &&
        <section
          className="w-100 clearfix BaraemMainSection"
          id="CoverPlanActive"
          style={{
            marginTop: "30px"
          }}>
          
            <div className="container customContainer2">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {translationMap?.addChild ?? "Add Child"}
                </h6>
              </div>
              <div className="Step_ul_main_box">
                <ul className="Step_Info_ul_box">
                  <li>
                    <div className="Step_inner_box active_box edit_box_border">
                      <div className="inner_counter_wrap">
                        <span className="count_box">1</span>
                        <p>
                          {translationMap?.regMethod ?? "Registration method"}
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="Step_inner_box">
                      <div className="inner_counter_wrap">
                        <span className="count_box">2</span>
                        <p>
                          {translationMap?.personalInfo ?? "Personal Information"}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="container customContainer customContainer3">
              <div className="cover_inner_wrapper">
                <div className="cover_main_box1">
                  {error &&
                <AlertDependent
                  setError={setError}
                  alert_text={translationMap?.unableToFindChild ?? "Unable to Find child"}
                  number_text={translationMap?.unableToFindChildSubText ?? "Please verify Information on the form."} />

                }

                  {ageError &&
                <AlertDependent
                  setError={setAgeError}
                  alert_text={translationMap?.unableToAddChild ??
                  "Unable to add a child"
                  }
                  number_text={translationMap?.greaterThanAgeRangeText ?? "Your child is older than the assement age range"} />


                }

                  {otpBlockError &&
                <AlertDependent
                  setError={setOtpBlockError}
                  alert_text={
                  translationMap?.otpBlocked ||
                  "OTP blocked due to multiple incorrect attempts. Try again after 5 minutes."
                  } />

                }

                  {userAlreadyPresentError &&
                <AlertDependent
                  setError={setUserAlreadyPresentError}
                  alert_text={translationMap?.recordPresentText ?? "Record already present"
                  } />

                }
                  <div className="baraem_main_inner_wrapper baraem_main_inner_form_wrapper">
                    <form
                    className="form_box radio_form"
                    onSubmit={(e) => {
                      if (isDropdownSelected) {
                        e.preventDefault();
                        handleDropdownContinue();
                      } else {
                        handleContinue(e);
                      }
                    }
                    }>
                    
                      <div className="input_field_box">
                        <h6 className="Gray_Title Title1">
                          {translationMap?.isYourChildReg ??
                        "Is your child registered in:"}
                        </h6>
                        <div className="input_inner_box">
                          <div className="row">
                            <div className="col-12 col-md-6 col-lg-6">
                              <div className="radio_box">
                                <input
                                type="radio"
                                id="baraemtest1"
                                name="radio-group"
                                className="messagebox"
                                checked={isDubaiHealthFacility}
                                onChange={handleFacilityChange}
                                tabIndex="0"
                                onKeyDown={(e) => {
                                  if (e.key === "Tab") {
                                    e.preventDefault();
                                    handleFacilityChange({ target: { id: "baraemtest1" } });
                                    document.getElementById("baraemtest2")?.focus();
                                  }
                                }} />

                              
                                <label htmlFor="baraemtest1">
                                  {translationMap?.dubaiHealthFacility ??
                                "Dubai Health Facility"}
                                </label>
                              </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6">
                              <div className="radio_box">
                                <input
                                type="radio"
                                id="baraemtest2"
                                name="radio-group"
                                className="messagebox1"
                                checked={!isDubaiHealthFacility}
                                onChange={handleFacilityChange}
                                tabIndex="0"
                                onKeyDown={(e) => {
                                  if (e.key === "Tab") {
                                    e.preventDefault();
                                    handleFacilityChange({ target: { id: "baraemtest2" } });
                                    document.getElementById("continue-btn")?.focus();

                                  }
                                }} />
                              
                                <label htmlFor="baraemtest2">
                                  {translationMap?.nonDubaiHealthFacility ??
                                "Non Dubai Health Facility"}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {isDubaiHealthFacility &&
                      <div className="textbox_message inputbox12">
                            <div className="row">
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label htmlFor="healthCardNumber">
                                    {translationMap?.heathCardNumber ??
                                "Health Card Number"}
                                  </label>
                                  <input
                                type="text"
                                name="healthCardNumber"
                                placeholder={
                                translationMap?.hcnumberPlaceholder ??
                                "XXXXXXXXXXX"
                                }
                                className="input_field"
                                value={mrn}
                                onChange={handleChangeMrn} />
                              
                                  {hcNumberError && <span style={{
                                color: 'red',
                                display: "block"
                              }}>{translationMap?.mrnValidationError ?? "Please enter valid Health Card Number"}</span>}

                                </div>
                              </div>
                              <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                  <label htmlFor="yearOfBirth">
                                    {translationMap?.yourChildDOB ??
                                "Your child year of birth"}
                                  </label>
                                  <input
                                type="text"
                                name="yearOfBirth"
                                maxLength={4}
                                placeholder="Eg. 2024"
                                className="input_field"
                                value={inputDob}
                                onChange={handleChangeUserInputDob} />
                              
                                  {birthYearError && <span style={{
                                color: 'red',
                                display: "block"
                              }}>{translationMap?.birthYearErrorMessageText ?? "Please enter valid date of birth"}</span>}

                                </div>
                              </div>
                              {!isLiferay && dependentList.length > 0 &&
                          <>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <h6 className="Gray_Title Title1">{translationMap?.orText ?? "Or"}</h6>
                                  </div>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="select_custom_box">
                                      <label htmlFor="selectChild">
                                        {translationMap?.selectChild ??
                                  "Select the Child"}
                                      </label>
                                      <div className="select_custom_box2 select">

                                        <div className="dropdown-form">
                                          <select
                                      id="dropdown"
                                      value={
                                      selectedMrnFromDropDown || ""
                                      }
                                      onChange={handleChildChange}>
                                      
                                            <option value="" disabled>
                                              {" "}
                                              {dependentList.length === 0 ?
                                        translationMap?.noChildPresent ??
                                        "No child present" :
                                        translationMap?.selectChildList ??
                                        "Select child from the list available"}
                                            </option>
                                            {dependentList.map((entry) =>
                                      <option
                                        key={entry.patientMRN}
                                        value={entry.patientMRN}>
                                        
                                                {`${capitalizeFirstLetter(entry.PatientFirstName)} ${capitalizeFirstLetter(entry.patientLastName || "")}`.trim()}
                                              </option>
                                      )}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <h6 className="blue_title">
                                      {translationMap?.note ?? "Note"}
                                    </h6>
                                  </div>
                                </>
                          }
                            </div>
                          </div>
                      }
                      </div>

                      <div className="Inner_Box">
                        <div className="form_buton_box">
                          <span>
                            <button type="submit"
                          id="continue-btn"
                          className="blue_btn_link">
                              {translationMap?.continue ?? "Continue"}
                            </button>
                          </span>
                          <span>
                            <button
                            onClick={() => navigate("/")}
                            className="bluetrans_btn_link">
                            
                              {translationMap?.back ?? "Back"}
                            </button>
                          </span>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="cover_main_box2"></div>
              </div>
            </div>
          </section>
        }
        {step === 1 &&
        <AddNonDubaiHealthChild
          setStep={setStep}
          // contactNumber={contactNumber}
          translationMap={translationMap}
          isDubaiHealthFacility={isDubaiHealthFacility}
          patientFirstName={patientFirstName}
          patientSex={patientSex}
          dateOfBirth={dateOfBirth}
          patientMobile={patientMobile}
          setPatientFirstName={setPatientFirstName}
          setPatientSex={setPatientSex}
          setDateOfBirth={setDateOfBirth}
          setPatientMobile={setPatientMobile}
          healthCardNumber={isDropdownSelected ? selectedMrnFromDropDown : mrn}
          ageInMonth={ageInMonth} />

        }

        {mobileNumberVerificationPupup &&
        <BaraemMobileNumberVerify
          setStep={setStep}
          setMobileNumberVerificationPupup={setMobileNumberVerificationPupup}
          mobileNum={patientMobile}
          setPatientFirstName={setPatientFirstName}
          setPatientMobile={setPatientMobile}
          setPatientSex={setPatientSex}
          setDateOfBirth={setDateOfBirth}
          uuid={uuid}
          mrn={isDropdownSelected ? selectedMrnFromDropDown : mrn}
          setAgeInMonth={setAgeInMonth}
          isDropdownSelected={isDropdownSelected}
          selectedMrnFromDropDown={selectedMrnFromDropDown}
          setUuid={setUuid}
          translationMap={translationMap} />

        }
      </div>
    </div>);

};

export default AddChild;